import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TrafficNewsOption } from '../../models/traffic-news-model';

@Component({
    selector: 'aa-traffic-options',
    templateUrl: './traffic-options.component.html',
    styleUrls: ['./traffic-options.component.scss'],
    standalone: false
})
export class TrafficOptionsComponent {

  @Input() optionData: Array<TrafficNewsOption>;
  @Output() optionSelected: EventEmitter<any> = new EventEmitter();

  constructor() { }

  updateCheckedOptions(option, event) {
    this.optionSelected.emit(this.optionData);
  }
  
  trackByFn(index: number): number {
    return index;
  }
}





